import DeliveryAddressesForm from '../../../../../components/Sales/Client/Contract/Form/DeliveryAddressesForm'
import FooterButtons from '../../../../../elements/Buttons/FooterButtons'
import useModalShow from '../../../../../elements/Hooks/useModalShow'
import DateCell from '../../../../../elements/Table/Cells/DateCell'
import React from 'react'
import { Button, Modal } from 'antd'
import moment from 'moment'
import { get, isEmpty } from 'lodash'
import { checkForm } from '../../../../../modules/Utils'
import CustomTable from '../../../../../elements/Table/CustomTable'

function DeliveryAddresses (props) {
  const { contract, updateContract } = props
  let uuid = moment().unix()

  console.log({ contract })

  let data = []
  if (!isEmpty(get(contract, 'deliveryAddresses')))
    data = contract.deliveryAddresses.map(item => ({ ...item }))
  data.forEach(i => {
    if (!i.key) i.key = (uuid++).toString()
  })

  const { visible, onShow, onCancel, payload } = useModalShow()
  const isNew = !get(payload, 'object')
  const ref = React.createRef()

  async function submit () {
    const data = await checkForm(ref)
    let newData = get(contract, 'deliveryAddresses') || []
    newData.push({ key: (uuid++).toString(), ...data })
    updateContract('deliveryAddresses', newData)
    onCancel()
  }

  function remove () {
    const key = payload.object.key
    let newData = get(contract, 'deliveryAddresses') || []
    newData = newData.filter(line => key !== line.key)
    updateContract('deliveryAddresses', newData)
    onCancel()
  }

  async function update () {
    const data = await checkForm(ref)
    const key = payload.object.key
    let newData = get(contract, 'deliveryAddresses') || []
    const target = newData.find(item => key === item.key)
    const item = { ...target, ...data }
    newData = newData.map(line => (line.key === key ? item : line))
    updateContract('deliveryAddresses', newData)
    onCancel()
  }

  const columns = [
    {
      Header: 'Key',
      accessor: 'key',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Title',
      accessor: 'title',
      width: 350,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value || '_NoName_'}</a>,
    },
    { Header: 'Country', accessor: 'delivery.country', width: 150,},
    { Header: 'LOCODE', accessor: 'delivery.location', width: 100, },
    { Header: 'Type', accessor: 'delivery.type', width: 100, },
    //{ Header: 'Date', accessor: 'delivery.date', Cell: DateCell },
    { Header: 'Address', accessor: 'delivery.address.label', },
  ]

  return (
    <>
      <Modal
        visible={visible}
        title={'Delivery Addresses'}
        onCancel={onCancel}
        destroyOnClose={true}
        footer={
          <FooterButtons
            submit={submit}
            remove={remove}
            update={update}
            title={'Delivery Address'}
            isNew={isNew}
            isEdit={!isNew}
          />
        }
        width={'75%'}>
        <DeliveryAddressesForm ref={ref} line={get(payload, 'object', {})}/>
      </Modal>
      <CustomTable
        data={data}
        defaultPageSize={20}
        isFilterable={true}
        CreateButton={() => (
          <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
            New
          </Button>
        )}
        columns={columns}
      />
    </>
  )
}

export default DeliveryAddresses
